module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/flow_02_sp-97d112688a980ab54251181e1b0d2413.png";